import './GraphItemBalloon.scss';

export const statsGraphBalloon = (title) => `\n
  <div class="graph-tooltip">\
    <div>${title}</div>\
    <div>[[dateLabel]] [[date]]</div>\
    <div class="title-balloon">[[title]]</div>\
    <div class="current-value">[[valueLabel]]</div>\
    <div class='growth-rate-block [[blockClass]]'>\
      <i class='[[iconClass]]'></i>\
      <div>[[change]]</div>\
    </div>\
  </div>\
`;

export const dailyMortalityBalloonHTML = `\n
  <div class="graph-tooltip">\
    <div>[[tooltip_date]] vs</div>\
    <div>[[tooltip_date_was]]</div>\
    <div class="title-balloon">[[title]]</div>\
    <div class="current-value">[[value]]%</div>\
    <div class='growth-rate-block [[blockClass]]'>
      <i class='[[iconClass]]'></i>
      <div>[[mortality_change]]</div>
    </div>\
  </div>\
`;

export const symptomsBalloonHTML = `
  <div class='graph-tooltip'>\
    <div>[[tooltip_date]] vs</div>\
    <div>[[tooltip_date_was]]</div>\
    <div class='title-balloon'>[[title]]</div>\
    <div class='current-value'>[[symptomatic]]%</div>\
    <div class='growth-rate-block [[blockClass]]'>\
      <i class='[[iconClass]]'></i><div>[[symptomatic_change]]</div>\
    </div>\
  </div>`;

export const avgMortalityRateBalloonHTML = (title) => `
    <div class='graph-tooltip'>\
      <div>${title}</div>\
      <div>[[startDate]] - [[endDate]]</div>\
      <div class='current-value'>[[avgValue]]%</div>\
      <div class='growth-rate-block [[rateClass]]'>\
        <i class='[[iconClass]]'></i>\
        <span>[[delta]]</span>\
      </div>\
    </div>\
  `;

export const closedGroupBalloon = `\
    <div class='line-balloon'>\
      [[name]] • [[closed_on]] • [[mortality_rate]]%
    </div>\
  `;

export const conditionBalloonHTML = `\
    <div class="line-balloon">\
      [[title]] • [[percent]]% ([[value]])
    </div>\
  `;

export const temperatureBalloonHtml = (formatMessage, showSetPoint) => `\
  <div class="graph-tooltip">\
    <div class="tooltip-date">\
      [[tooltip_date]]\
    </div>\
    <div class="values-wrap">\
      <div class="value">\
        ${formatMessage({ id: 'general.high' })} • [[high_label]]\
      </div>\
      <div class="value">\
        ${formatMessage({ id: 'general.low' })} • [[low_label]]\
      </div>\
      ${showSetPoint ? `<div class="value">\
        ${formatMessage({ id: 'general.setPoint' })} • [[set_point_label]]\
      </div>` : ''}\
    </div>\
  </div>\
`;

export const waterUsageBallonHtml = (formatMessage, measurementSystem) => {
  const isMetric = measurementSystem === 'metric';
  const consumedId = isMetric
    ? 'component.dataTable.headers.totalLitersConsumed'
    : 'component.dataTable.headers.totalGallonsConsumed';
  const perHeadId = isMetric
    ? 'component.dataTable.headers.totalLitersPerHead'
    : 'component.dataTable.headers.totalGallonsPerHead';
  const averageId = isMetric ? 'general.averageLitersPerHead' : 'general.averageGallonsPerHead';

  return `\
  <div class="graph-tooltip">\
    <div class="tooltip-date">\
      [[tooltip_date]]\
    </div>\
    <div class="values-wrap">\
      <div class="value">\
      ${formatMessage({ id: consumedId })} • [[water_usage_value]]\
      </div>\
      <div class="value">\
        ${formatMessage({ id: 'component.dataTable.headers.totalInventory' })} • [[pigs]]\
      </div>\
      <div class="value">\
        ${formatMessage({ id: perHeadId })} • [[formattedValue]]\
      </div>\
    </div>\
    <div class="values-wrap orange">\
      <div class="value">\
      ${formatMessage({ id: averageId })} • [[average]]\
      </div>\
    </div>\
  </div>\
`;
};
